import React from "react";
import Header from "../header/header";
import { PRACTICE_EDITION_WHITELABEL } from "../../constants/constants";
import "./styles.scss";

const Layout = (props) => {
  const { testId } = props;
  return (
    <section className="app-wrapper" data-testid={testId}>
      {!PRACTICE_EDITION_WHITELABEL && (
        <div className="desktop-header">
          <Header />
        </div>
      )}

      <div
        className={
          PRACTICE_EDITION_WHITELABEL
            ? "app-main-container app-container-without-header"
            : "app-main-container"
        }
      >
        {props.children}
      </div>
    </section>
  );
};

export default Layout;
